<template>
  <div class="trainingCamp">
    <div class="trainingCamp-content" v-loading="loading">
      <div class="camp-item" v-for="(item,index) in entranceList" :key="index">
        <div class="operate" :class="[item.endApply===1 ? 'disabled': '']" v-if="item.status!==13&&(item.status===1||item.status===2)">
          <p @click="handleExamine(item,3)">请假</p>
          <span></span>
          <p @click="handleExamine(item,5)">换人</p>
        </div>
        <p class="name">{{item.name}}</p>
        <div class="status-box">
          <div>
            <p :class="[item.roleClass.class]">{{item.isOnline+item.roleClass.text}}</p>
            <p :class="[item.statusClass.class, item.endApply===1 ? 'status-endApply': '']">{{item.statusClass.text}}</p>
          </div>
        </div>
        <div class="camp-name">{{item.campsName}}</div>
        <div class="cycle-time">本期培训时间：{{`${item.startTime}~${item.endTime}`}}</div>
        <div class="end-time">报名截止时间：{{item.endApplyTime}}</div>
        <div class="camp-address">{{item.isOnline==='线下'?'线下培训地点：'+item.address:'线上培训形式：报名成功后，魔法校老师会与您沟通'}}</div>
        <div class="camp-quota">已报名/可用名额：{{`${item.usedNum}/${item.maxNum}`}}</div>
        <div class="bottom">
          <button :class="[item.buttonClass.class, item.endApply===1 ? 'button-endApply': '']" @click="handleButton(item)">{{item.buttonClass.text}}</button>
        </div>
      </div>
    </div>
    <div v-if="emptyInfo" class="empty">
      <p>{{ emptyInfo }}</p>
    </div>    
  </div>
</template>

<script>
import apiTrainingCamp from '@/services/trainingCamp.js'
import { getUser } from '@/utils/auth'
export default {
  data () {
    return {
      loading: false,
      emptyInfo: '',
      entranceList: []
    }
  },
  created () {
    this.examineMap = {
      3: {
        title: '确认请假 ',
        msg: '请假即您主动放弃本期培训营的报名，您机构的本次培训营名额将会释放到下一期培训营当中',
        info: '已取消请假'
      },
      5: {
        title: '确认换人',
        msg: '换人后可重新编辑本次训练营的报名人信息，报名截止后要修改请联系跟您对接的魔法校商务老师',
        info: '已取消换人'
      }
    }
    this.params = {
      schoolId: getUser().school_id
    }
    this.getEntranceList()
    this.postCheckIsCanEnroll()
  },
  methods: {
    postCheckIsCanEnroll () {
      apiTrainingCamp.checkIsCanEnroll({schoolId: this.params.schoolId}).then((res) => {
        if (res.ok) {
          this.isRole1CanEnroll = res.data === 'true'
        }
      })
    },
    getEntranceList () {
      this.loading = true
      apiTrainingCamp.entranceList(this.params).then((res) => {
        this.loading = false
        if (res.ok) {
          if (res.data && res.data.length) {
            this.entranceList = this.setEntranceList(res.data)
            this.emptyInfo = ''
          } else {
            // this.emptyInfo = res.message
            this.emptyInfo = '当前无可报名共创营或名额，可联系您的专属运营了解具体情况'
          }
        } else {
          // this.emptyInfo = res.message
          this.emptyInfo = '当前无可报名共创营或名额，可联系您的专属运营了解具体情况'
        }
      }).catch(() => {
        this.emptyInfo = '当前无可报名共创营或名额，可联系您的专属运营了解具体情况'
      })
    },
    setEntranceList (data) {
      const arr = data.map((item) => {
        switch (item.role) {
          case 0:
            item.roleClass = {
              text: '校长',
              class: 'type-master'
            }
            break
          case 1:
            item.roleClass = {
              text: '主管',
              class: 'type-tutor'
            }
            break
          case 2:
            item.roleClass = {
              text: '辅导老师',
              class: 'type-tutor'
            }
            break
        }
        switch (item.status) {
          case 11:
            item.statusClass = {
              text: '待报名',
              class: 'status-a'
            }
            item.buttonClass = {
              text: '现在报名',
              class: 'button-primary'
            }
            break
          case 1:
            item.statusClass = {
              text: '待审核',
              class: 'status-b'
            }
            item.buttonClass = {
              text: '已报名',
              class: 'button-disabled'
            }
            break
          case 2:
            item.statusClass = {
              text: '审核通过',
              class: 'status-c'
            }
            item.buttonClass = {
              text: '已报名',
              class: 'button-disabled'
            }
            break
          case 4:
            item.statusClass = {
              text: '审核未通过',
              class: 'status-d'
            }
            item.buttonClass = {
              text: '重新报名',
              class: 'button-primary'
            }
            break
          case 3:
            item.statusClass = {
              text: '已请假',
              class: 'status-e'
            }
            item.buttonClass = {
              text: '已报名',
              class: 'button-disabled'
            }
            break
          case 5:
            item.statusClass = {
              text: '待换人',
              class: 'status-f'
            }
            item.buttonClass = {
              text: '重新报名',
              class: 'button-primary'
            }
            break
          case 12:
            item.statusClass = {
              text: '待报名',
              class: 'status-b'
            }
            item.buttonClass = {
              text: '已报满',
              class: 'button-warning'
            }
            break
          case 13:
            item.statusClass = {
              text: '审核通过',
              class: 'status-c'
            }
            item.buttonClass = {
              text: '等待开营',
              class: 'button-disabled'
            }
            break
        }

        return item
      })
      return arr
    },
    handleExamine (item, status) {
      if (item.endApply === 1) return
      this.$confirm(this.examineMap[status].msg, this.examineMap[status].title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postExamine(item.id, status)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.examineMap[status].info
        })
      })
    },
    postExamine (id, status) {
      const params = {id, status}
      apiTrainingCamp.examine(params).then((res) => {
        if (res.ok) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.getEntranceList()
        }
      })
    },
    handleButton (item) {
      if (item.endApply === 1) {
        return
      }
      if (item.type === '辅导营' && !this.isRole1CanEnroll) {
        this.$message({
          type: 'error',
          message: '校长报完名后，其他员工才能进行报名'
        })
        return
      }
      if (item.status === 11 || item.status === 4 || item.status === 5) {
        this.$router.push({name: 'trainingCampEnroll', query: {schoolId: this.params.schoolId, campsId: item.campsId, id: item.id, role: item.role, campsName: encodeURIComponent(item.campsName)}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.trainingCamp {
  position: relative;
  padding-top: 34px;
  width: 1200px;
  z-index: 9;
  background-color: #f3f5f7;
}
.trainingCamp-content {
  display: flex;
  flex-wrap: wrap;
  margin-right: -20px;
}
.camp-item {
  position: relative;
  margin-right: 16px;
  margin-bottom: 16px;
  padding: 20px;
  width: 288px;
  text-align: left;
  background-color: #FFFFFF;
  box-sizing: border-box;
  .name {
    height: 23px;
    line-height: 23px;
    font-size: 16px;
    font-weight: 500;
    color: #202428;
  }
  .status-box {
    display: flex;
    align-items: center;
    height: 36px;
    div {
      display: flex;
      // margin-left: -62px;
      // width: 248px;
      // transform: scale(0.5,0.5);
    }
    p {
      margin-right: 5px;
      padding: 0 5px;
      // height: 32px;
      line-height: 24px;
      font-size: 13px;
      font-weight: 500;
      color: #FFFFFF;
      border-radius: 3px;
    }
    .type-master {
      background-color: #77A9AC;
    }
    .type-tutor {
      background-color: #8E8AC8;
    }
    // a: 待报名，-b：待审核，c：审核通过，d：审核未通过，e：已请假，f：待换人
    .status-a {
      color: #8E9DAE;
      background-color: #EBEEF3;
    }
    .status-b {
      color: #2FA1FF;
      background-color:rgba(47,161,255,0.1);
    }
    .status-c {
      color: #2AD099;
      background-color: #E9FBF5;
    }
    .status-d {
      color: #FF0000;
      background-color: #FFDFD8;
    }
    .status-e {
      color: #FA653D;
      background-color: #FFEB9F;
    }
    .status-f {
      color: #FA653D;
      background-color: #FFF2EF;
    }
    .status-endApply {
      color: #8E9DAE;
      background-color: #EBEEF3;
    }
  }
  .cycle-time, .camp-name {
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    color: #626D7B;
  }
  .camp-name {
    font-weight: 500;
    color: #202428;
  }
  .end-time, .camp-quota {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: #626D7B;
  }
  .camp-address {
    line-height: 20px;
    font-size: 12px;
    color: #626D7B;
  }
  .bottom {
    display: flex;
    justify-content: center;
    margin-top: 14px;
  }
  .button-disabled, .button-primary, .button-warning {
    display: flex;
    justify-content: center;
    align-items: center;
    width:102px;
    height:34px;
    border-radius:3px;
    border:1px solid #EEEEEE;
    font-weight:500;
    font-size: 14px;
    color: #BEC9D0;
    background-color: #FFFFFF;
  }
  .button-primary {
    color: #0182FF;
    border-color: #0182FF;
    cursor: pointer;
  }
  .button-warning {
    color: #FF5555;
    border-color: #FF5555;
  }
  .button-endApply {
    color: #BEC9D0;
    background-color: #FFFFFF;
  }
  .operate {
    position: absolute;
    top: 20px;
    right: 10px;
    display: flex;
    align-items: center;
    height: 23px;
    font-size: 12px;
    color: #0182FF;
    cursor: pointer;
    &.disabled {
      color: #BEC9D0;
    }
    p {
      padding: 2px 9px;
    }
    span {
      height: 12px;
      font-size: 0;
      border-right: 1px solid green;
    }
  }
}
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
  width: 100%;  
  height: 70%;
  p {
    padding-top: 164px;
    background: url(~@/assets/image/empty.png) no-repeat center top;
    background-size: 144px 144px;
    line-height: 20px;
    font-size: 14px;
    color: #666666;
  }
}
</style>
